import moment from "moment";
import React, { useState, useEffect, Fragment } from "react";

let dayArr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const useHolidayCalendarTable = (
  holidayCalendarData,
  
  handleDelHolidayCalendar,
  handleEditHolidayCalendar,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Year", "Title", "Date", "Day", "Type", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
      
    let trowArr = holidayCalendarData.map((el) => {
      let selectedoptions1=[];
      
      return {
        Year: new Date(el.holidayDate).getFullYear(),
        Title: el.title,
        Date: moment(el.holidayDate).format("DD-MM-YYYY"),
        Day: dayArr[el.day],
        Type:el.type,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"
              style={{ marginRight: "10px", cursor: "pointer" }}
              onClick={() => {
                handleEditHolidayCalendar(el, el.holidayCalendarId);
                onClickToggleFromTable();
              }}
            ></i> &nbsp;
            <i
              className="fas fa-trash"
              onClick={() => handleDelHolidayCalendar(el.holidayCalendarId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

    setTrow(trowArr);
  }, [
    holidayCalendarData,
    handleDelHolidayCalendar,
    handleEditHolidayCalendar,
    onClickToggleFromTable,
  ]);

  return { thead, trow };
};

export default useHolidayCalendarTable;
